import { FC, useRef, useEffect, useState, PropsWithChildren } from 'react'
import { shallowEqual, useSelector, connect, useDispatch, ConnectedProps } from 'react-redux'
import { LayoutSplashScreen } from '../../../../_template/layout/core'
import * as merchant from './MerchantRedux'
import { getMerchant } from './MerchantCRUD'
import { RootState } from '../../../../setup'

const mapState = (state: RootState) => ({ merchant: state.merchant })
const connector = connect(mapState, merchant.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const MerchantInit: FC<PropsWithChildren<PropsFromRedux>> = (props) => {
    const didRequest = useRef(false)
    const dispatch = useDispatch()
    const [showSplashScreen, setShowSplashScreen] = useState(true)
    const merchant = useSelector<RootState>(({ merchant }) => merchant.merchant, shallowEqual)

    useEffect(() => {
        const requestMerchant = async () => {
            try {
                if (!didRequest.current) {
                    const { data: merchant } = await getMerchant()
                    dispatch(props.setMerchant(merchant.data))
                }
            } catch (error) {
                console.error(error)
            } finally {
                setShowSplashScreen(false)
            }

            return () => (didRequest.current = true)
        }

        if (merchant) {
            setShowSplashScreen(false)
        } else {
            requestMerchant()
        }
    }, [])

    return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(MerchantInit)